import { CFormCheck } from '@coreui/react-pro'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { dynamicInputGenerator } from 'src/helper/dynamicInputGenerator'
import DiagnosisPlan from './DiagnosisPlan'
import DynamicInputs from '../../../components/NewEncounter/DynamicInputs'

const OptionItem = ({ index, section, wholeData, inputObjOnChange, tabData, setTabData }) => {
  // TODO- this needs to be debounced or rewritten
  const inputOnChange = (dataVal) => {
    const updatedData = [...wholeData]
    updatedData[index] = dataVal
    inputObjOnChange(updatedData)
  }

  return (
    <div className={'option-item'}>
      {dynamicInputGenerator(
        section?.options?.[index],
        section,
        inputOnChange,
        tabData,
        setTabData,
      )}
    </div>
  )
}

const RadioButtonFields = ({ options, section, inputObjOnChange, disabled, isMIPS }) => {
  return (
    <div className="checkbox-holder">
      <div className="checkbox-group">
        {options?.map((option, index) => {
          const isChecked = section?.value === (option?.label || option?.value)
          return (
            <div key={index}>
              <div className={isMIPS ? 'mips-title-holder' : ''}>
                <CFormCheck
                  type="radio"
                  value={option?.label || option?.value}
                  disabled={disabled}
                  label={option?.label || option?.value}
                  name={section?._id || section?.label}
                  onChange={(e) => {
                    inputObjOnChange({ ...section, value: e.currentTarget?.value })
                  }}
                  checked={isChecked}
                />
                {isMIPS && (
                  <div className="thumb-holder">
                    {option?.tip && (
                      <>
                        {option?.tip === '&#x1f44d;' ? (
                          <div className="unicode-icon green">
                            <i className="fa-regular fa-circle-check icon"></i>
                          </div>
                        ) : option?.tip === '&#x1f44e;' ? (
                          <div className="unicode-icon red">
                            <i className="fa-regular fa-triangle-exclamation icon"></i>
                          </div>
                        ) : (
                          <div
                            className="unicode-icon"
                            dangerouslySetInnerHTML={{ __html: option?.tip }}
                          />
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>

              {/*{isChecked && option?.inputs && (*/}
              {/*  <div className="input-holder">*/}
              {/*    {option?.inputs?.map((input, index) => (*/}
              {/*      <DynamicInputs*/}
              {/*        input={input}*/}
              {/*        key={index}*/}
              {/*        onChange={(data) => inputObjOnChange(data)}*/}
              {/*        index={index}*/}
              {/*        option={option}*/}
              {/*      />*/}
              {/*    ))}*/}
              {/*  </div>*/}
              {/*)}*/}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default function SectionItem({
  section,
  onTemplateFill,
  sectionTitle,
  inputDataOnChange,
  index,
  wholeSection,
  noTitle,
  isMIPS,
  setIsTyping,
}) {
  const selectedTemplate = useSelector((state) => state?.progressNote?.selectedTemplate)

  const [tabData, setTabData] = useState()
  const isEnabled = Boolean(section?.isChecked)

  const inputObjOnChange = (dataVal) => {
    let newWholeData = selectedTemplate?.data?.find(
      (item) => item.title === wholeSection?.title,
    )?.sections

    if (newWholeData) {
      let tempData = [...newWholeData]

      if (tempData[index].options) {
        tempData[index] = { ...tempData[index], options: dataVal }
      }

      inputDataOnChange(tempData)
    }
  }

  const inputRadioObjOnChange = (dataVal) => {
    let newWholeData = selectedTemplate?.data?.find(
      (item) => item.title === wholeSection?.title,
    )?.sections

    if (newWholeData) {
      let tempData = [...newWholeData]

      tempData[index] = dataVal

      inputDataOnChange(tempData)
    }
  }

  const isRelative = section?.disable && !isMIPS

  return (
    <div
      className={`section-item ${isRelative ? 'position-relative' : ''}`}
      onClick={() => {
        setIsTyping(false)
      }}
    >
      {isRelative && <div onClick={(e) => e.stopPropagation()} className="disable-overlay"></div>}

      {!noTitle && !(section?.hydeCode === true) && (
        <>
          {section?.checkbox ? (
            <div className="title-head">
              <CFormCheck
                className="input-box txtbox-lbl"
                checked={isEnabled}
                label={section?.label}
                onChange={(e) => {
                  inputRadioObjOnChange({ ...section, isChecked: e.currentTarget?.checked })
                }}
              />
            </div>
          ) : (
            section?.label && (
              <div className={`label-head`}>
                <label className="txtbox-lbl">{section?.label}</label>
                {isMIPS && section?.value && (
                  <div className="mips-action">
                    <div
                      className="btn btn-secondary"
                      onClick={() => {
                        let newWholeData = selectedTemplate?.data?.find(
                          (item) => item.title === wholeSection?.title,
                        )?.sections

                        if (newWholeData) {
                          let tempData = [...newWholeData]

                          tempData[index] = { ...tempData[index], value: null }

                          inputDataOnChange(tempData)
                        }
                      }}
                    >
                      Clear
                    </div>
                  </div>
                )}
              </div>
            )
          )}
        </>
      )}

      {(isEnabled || !section?.checkbox) && (
        <div className="option-holder">
          {section?.type === 'input' ? (
            section?.options?.map((option, index) => (
              <OptionItem
                key={index}
                section={section}
                index={index}
                inputObjOnChange={inputObjOnChange}
                wholeData={section?.options}
                tabData={tabData}
                setTabData={setTabData}
              />
            ))
          ) : section?.type === 'radio' ? (
            <>
              <RadioButtonFields
                options={section?.options}
                inputObjOnChange={inputRadioObjOnChange}
                section={section}
                onTemplateFill={onTemplateFill}
                sectionTitle={sectionTitle}
                isMIPS={isMIPS}
              />
            </>
          ) : section?.type === 'diagnosisPlan' || section?.type === 'diagnosis' ? (
            <>
              <DiagnosisPlan
                section={section}
                sectionTitle={sectionTitle}
                index={index}
                inputObjOnChange={inputObjOnChange}
              />
            </>
          ) : (
            <p></p>
          )}
        </div>
      )}
    </div>
  )
}
